import React from "react"

import PropTypes from "prop-types"

import {Page} from "../../constants/page/pages"
import {PagesArchitecture} from "../../constants/page/pagesArchitecture"
import ErrorBoundaryContainer from "../../shared-components/components/ErrorBoundary/errorBoundaryContainer"
import StyleLoaderContainer from "../../shared-components/components/StyleLoader/styleLoaderContainer"
import {SERVICE_BENEFICIARY_AREA} from "../../shared-components/constants/areaTypes"
import {getDynamicConfigurationValue} from "../../store/selectors/localStorage/dynamicConfigurationSelectors"
import {areCustomizedStyle, getStyle} from "../../store/selectors/localStorage/styleSelectors"
import {getTexts, isCustomizedTexts} from "../../store/selectors/localStorage/textSelector"
import defaultStyle from "../../styles/defaultStyle"

const StyleLoaderLayout = ({children}) => {
    return (
        <StyleLoaderContainer
            customStyle={defaultStyle}
            espaceType={SERVICE_BENEFICIARY_AREA}
            getDynamicConfigurationValue={getDynamicConfigurationValue}
            getStyle={getStyle}
            getTexts={getTexts}
            isCustomizedStyle={areCustomizedStyle}
            isCustomizedTexts={isCustomizedTexts}
        >
            <ErrorBoundaryContainer routeToRedirect={PagesArchitecture[Page.HOME].route}>
                {children}
            </ErrorBoundaryContainer>
        </StyleLoaderContainer>
    )
}

StyleLoaderLayout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default StyleLoaderLayout
